import React, { useEffect, useState } from 'react'
import SurveyListHeader from '../../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../../component/common/layout/SurveyListSidebar'
import style from "../../../../../style.module.css";
import QuestionScreen1 from './QuestionScreen1'
import QuestionScreen2 from './QuestionScreen2'
import QuestionScreen3 from './QuestionScreen3'
import QuestionScreen4 from './QuestionScreen4'
import QuestionScreen5 from './QuestionScreen5'
import QuestionScreen6 from './QuestionScreen6'
import { Card } from '@material-ui/core';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { clearSurveyFormData } from '../../../../../../store/actions/surveyAction';
import { useTranslation } from 'react-i18next';


export default function NewSurveyQuestionaire() {
    //States
    const [currentScreen, setCurrentScreen] = useState(1)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation();

    //Screen navigation
    const changeScreen = (type) => {
        if (type === 'INCREMENT') {
            setCurrentScreen(currentScreen + 1)
        } else if (type === 'DECREMENT') {
            setCurrentScreen(currentScreen - 1)
        } else if (type === 'SKIP') {
            setCurrentScreen(currentScreen + 2)
        }
    }

    const cancelSurvey = () => {
        dispatch(clearSurveyFormData())
        navigate('/admin/survey/list')
    }

    // const formData = useSelector((state) => state.surveyData?.addSurveyFormData)
    // console.log('formData', formData)

    return (
        <>
            <div className='d-flex flex-wrap flex-column main-outer-wrapper main-site-wrapper language-page onb'>
                <SurveyListHeader />
                <div id="viewport" className="d-flex">
                    <SurveyListSidebar />
                    <div className=" dashboard-page-outer flex-grow-1 page-content-wrap d-flex align-items-start align-items-lg-center justify-content-lg-center flex-column">
                        {currentScreen === 1 && <QuestionScreen1 changeScreen={changeScreen} />}
                        {currentScreen === 2 && <QuestionScreen2 changeScreen={changeScreen} />}
                        {currentScreen === 3 && <QuestionScreen3 changeScreen={changeScreen} />}
                        {currentScreen === 4 && <QuestionScreen4 changeScreen={changeScreen} />}
                        {currentScreen === 5 && <QuestionScreen5 changeScreen={changeScreen} />}
                        {currentScreen === 6 && <QuestionScreen6 changeScreen={changeScreen} />}
                    </div>
                </div>
            </div>

            <div className="customvar-modal modal custom-modal fade deleteModal" id="cancelSurvey" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0" + " " + style.card} >

                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>{t('survey.del2')}</h3>
                                                <p>{t('survey.del1')} </p>
                                            </div>
                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" data-bs-dismiss="modal">{t('settings.team.create_team.cancel')}</button>
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => cancelSurvey()}>{t('survey.customVariable.confirm_delete')}</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div >
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
